import React from "react";
import { TIMESHEET_ENTRY_TYPES } from "../types/Timesheet";

const ENTRY_CATEGORIES: Array<{
  label: string;
  value: keyof typeof TIMESHEET_ENTRY_TYPES;
}> = [
  {
    label: "Regular Time",
    value: "REGULAR",
  },
  {
    label: "Regular OT",
    value: "OVERTIME",
  },
  {
    label: "Regular DT",
    value: "DOUBLE",
  },
  {
    label: "Field Time",
    value: "FIELD",
  },
  {
    label: "Field OT",
    value: "FIELD_OVERTIME",
  },
  {
    label: "Field DT",
    value: "FIELD_DOUBLE",
  },
  {
    label: "Field Travel",
    value: "TRAVEL",
  },
  {
    label: "Vacation",
    value: "VACATION",
  },
  {
    label: "Sick",
    value: "SICK",
  },
  {
    label: "Banked Hours",
    value: "BANKED_HOURS",
  },
  {
    label: "LOA",
    value: "LOA",
  },
];

export const getEntryCategoryOptions = (): Array<{
  label: string;
  value: keyof typeof TIMESHEET_ENTRY_TYPES;
}> => {
  return ENTRY_CATEGORIES;
};

// Handle key down event for number input fields to allow only numeric input
export const handleNumberInputKeyDown = (
  e: React.KeyboardEvent<HTMLInputElement>
) => {
  if (
    !/^[0-9]$/.test(e.key) &&
    e.key !== "Backspace" &&
    e.key !== "ArrowLeft" &&
    e.key !== "ArrowRight" &&
    e.key !== "Tab" &&
    e.key !== "Delete" &&
    e.key !== "Home" &&
    e.key !== "End"
  ) {
    e.preventDefault();
  }
};
